import { useMemo, useState } from 'react'

import EditPricingModal from './EditPricingModal'
import LineItem from './LineItem'
import { useQuotePricing } from './QuotePricingProvider'

type Props = {
  period: 'monthly' | 'annual'
  employeeCount: number
}

export default function Pricing ({ period, employeeCount }: Props) {
  const { hasPricing, getTotalCost, workflowType } = useQuotePricing()
  const [editPricingModalOpen, setEditPricingModalOpen] = useState(false)

  const totalCost = useMemo(() => {
    const multiplier = period === 'monthly' ? 1 : 12
    return getTotalCost(employeeCount) * multiplier
  }, [getTotalCost, employeeCount, period])

  if (!hasPricing) {
    return null
  }

  return (
    <div className='flex flex-col flex-1'>
      <LineItem
        label='Thatch platform fees'
        cost={totalCost}
        tooltip='The estimated total that will be billed for Thatch platform fees (based on number of enrolled employees)'
        isEditable={workflowType === 'sales'}
        onClickEdit={() => setEditPricingModalOpen(true)}
        testId={`${period}-platform-fees`}
      />
      <EditPricingModal
        open={editPricingModalOpen}
        onOpenChange={setEditPricingModalOpen}
        employeeCount={employeeCount}
      />
    </div>
  )
}
